import React, { useEffect, useState } from 'react';
import { fetchVideoDownloadOptions, friendlyError } from '@/lib/api';
import { toast } from 'sonner';
import { DownloadActionButton } from './DownloadActionButton';

/**
 * Fase 06D · Renderiza el botón de descarga de un VÍDEO oficial.
 * Reutilizado desde la ficha pública del jugador (highlight) y el listado
 * privado "Mis highlights oficiales". Si el vídeo no tiene un asset ni
 * un producto asociado, no renderiza nada (evita ruido en la UI).
 */
export function VideoDownloadInline({ videoId, compact = true, className = '' }) {
  const [loading, setLoading] = useState(true);
  const [options, setOptions] = useState(null);

  useEffect(() => {
    let alive = true;
    (async () => {
      if (!videoId) { setLoading(false); return; }
      try {
        const data = await fetchVideoDownloadOptions(videoId);
        if (alive) setOptions(data);
      } catch (err) {
        if (alive) toast.error(friendlyError(err));
      } finally {
        if (alive) setLoading(false);
      }
    })();
    return () => { alive = false; };
  }, [videoId]);

  if (loading) return null;
  // Silencio total si no hay ni asset ni producto (no distraer al usuario).
  if (!options?.asset && !options?.product) return null;

  return (
    <div className={`mt-2 ${className}`}>
      <DownloadActionButton options={options} compact={compact} testIdBase={`video-download-${videoId}`} />
    </div>
  );
}
